/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { IntegrationSyncInfoFeatures } from './integrationSyncInfoFeatures';
import type { IntegrationSyncInfoStatus } from './integrationSyncInfoStatus';
import type { IntegrationSyncInfoSyncDirection } from './integrationSyncInfoSyncDirection';

/**
 * Per-integration sync rung-compatibility block. ``available`` carries the
 * derived capability ``features`` matrix; ``planned`` (ATS entries without a
 * registered profile) carries no features.
 */
export interface IntegrationSyncInfo {
  status: IntegrationSyncInfoStatus;
  features?: IntegrationSyncInfoFeatures;
  sync_direction?: IntegrationSyncInfoSyncDirection;
}
